<div #header class="frc__top container-fluid"
     tabindex="-1">
  <div *ngIf="hasPreviousUrl && !isShowcaseFullPage" class="row">
    <div class="col">
      <button (click)="goToPreviousPage()"
              class="back"
              data-automation-id="back-button">
        <span class="icon-back icon"></span>
        <span class="text" translate>back</span>
      </button>
    </div>
  </div>

  <div class="top-layout-grid row">

    <div class="col content-wrapper">
      <div class="top-layout-grid__image-wrapper mr-4">
        <div class="top-layout-grid__image main-book-cover">
          <app-cover
            [config]="coverConfig"
            [title]="title"
            [author]="author"
            [materialType]="materialType"
            data-automation-id="full-card-image"
            size="large">
          </app-cover>
        </div>

        <app-syndetics-unbound-see-full-excerpt *ngIf="formatGroup.identifiers?.isbn"
                                                [isbn]="formatGroup.identifiers?.isbn">
        </app-syndetics-unbound-see-full-excerpt>
      </div>

      <div class="top-layout-grid__links mt-6 mr-4" *ngIf="!isRapido">
        <app-preview-links [identifiers]="formatGroup.identifiers"></app-preview-links>
        <app-custom-pass-through [searchData]="searchData"
                                  [isInnReachSearchAvailable]="isInnReachSearchAvailable">
        </app-custom-pass-through>
        <div class="monster-help-pos-relative d-none d-lg-block">
          <app-monster-help-v2 class="monster-details"></app-monster-help-v2>
        </div>
      </div>
      <div class="top-layout-grid__content d-flex flex-column">
        <!--  TODO: There is no eContent in formatGroup currently (Remove of fix)
        <div class="card-type d-flex align-items-center" *ngIf="formatGroup?.eContent">
          <img class="vendor-logo mr-3 mb-2" *ngFor="let content of formatGroup.eContent"
           [src]="'assets/' + content.vendor + '.png'"
           [alt]="content.vendor">
        </div>
      -->

        <h2 *ngIf="formatGroup?.title"
            [tippy]="formatGroup.title"
            class="title mb-0 line-clamp line-clamp--two"
            data-automation-id="full-card-title"
        >{{ formatGroup.title }}</h2>

        <div *ngIf="formatGroup?.primaryAgent?.label?.length" class="mt-1 full-card-author"
          data-automation-id="full-card-author">
          <div class="author">
            <ng-container *ngIf="isRapido; else normalLink">
              <span class="link no-underline">
                {{ formatGroup.primaryAgent.label }}
              </span>
            </ng-container>
            <ng-template #normalLink>
              <a [queryParams]="{ id: formatGroup.primaryAgent.id, entityType: 'Agent' }" [routerLink]="['/search', 'card']"
                class="link">
                {{ formatGroup.primaryAgent.label }}
              </a>
            </ng-template>
          </div>
        </div>
        <div class="date mt-1" data-automation-id="search-card-info">
          <span class="card__publication-info">
            <ng-container *ngIf="formatGroup.publicationDate">{{'publicationInfo' | translate}}
              : {{ formatGroup.publicationDate }}</ng-container>
            <ng-container *ngIf="formatGroup.publicationDate"> | </ng-container>
            <ng-container *ngIf="formatGroup.language">{{ language }}</ng-container>
          </span>
        </div>
        <div *ngIf="formatGroup?.seriesTitle" class="mt-1">
          <div class="series-info-title">
            <a href=""
               data-automation-id="series-title"
               (keydown.enter)="$event.preventDefault(); onSeriesTypeSearch($event, formatGroup.seriesTitle, formatGroup.seriesTitleSearch)"
               (click)="$event.preventDefault(); onSeriesTypeSearch($event, formatGroup.seriesTitle, formatGroup.seriesTitleSearch)"
               class="link">
              <fa-icon [icon]="booksIcon" class="mr-1"></fa-icon>
              <span>{{ formatGroup.seriesTitle }}</span>
            </a>
          </div>
        </div>
      </div>

      <div class="toolbar" *ngIf="!isRapido">
        <app-format-group-toolbar-line [fgOrEntity]="formatGroup" [materialType]="materialType" [text]="textInsideDescription" [images]="coverConfig"></app-format-group-toolbar-line>
      </div>

      <div *ngIf="descriptionVisibilityCondition" class="description mt-3" data-automation-id="full-card-description">
        <app-cut-text-with-certain-height
          [source]="sourceDescription"
          [text]="textInsideDescription"
          [url]="fullCardDescriptionUrl"
          class="more-less-link-frc"
          height="70"
          moreLessColor="#00778A"
          minLengthToCut="60">
        </app-cut-text-with-certain-height>
      </div>

      <ng-container *ngIf="!isRapido; else rapido">
        <div class="tabs mt-6">
          <app-overdrive-and-sierra-availability-container
            (availabilityUpdatesChange)="onMaterialTypesDataChange($event)"
            [containerData]="formatGroup.materialTabs" [resourceId]="formatGroup.id">
            <ng-template let-availabilityUpdates="availabilityUpdates">
              <app-rollup-tabs-card-header
                (getIt$)="getIt$.emit($event)"
                (placeHold$)="placeHold$.emit($event)"
                (tableInited)="onTableInited()"
                [fgId]="formatGroup.id"
                [fgTitle]="formatGroup.title"
                [isbn]="isbn"
                [author]="author"
                [materialTabs]="formatGroup.materialTabs"
                [availabilityUpdates]="availabilityUpdates"
                [language]="language"
                class="rollup-card"
                data-automation-id="rollup-tabs-card-header">
              </app-rollup-tabs-card-header>
            </ng-template>
          </app-overdrive-and-sierra-availability-container>
        </div>
      </ng-container>

      <ng-template #rapido>
        <div class="tabs mt-6">
          <app-rollup-tabs-card-header-rapido
            [fgId]="formatGroup.id"
            [fgTitle]="formatGroup.title"
            [materialTabs]="formatGroup.materialTabs"
            [language]="language"
            [isbn]="formatGroup.identifiers?.isbn"
            class="rollup-card"
            data-automation-id="rollup-tabs-card-header">
        </app-rollup-tabs-card-header-rapido>
        </div>
      </ng-template>
    </div>
  </div>
</div>
